import { render, staticRenderFns } from "./main-layout.vue?vue&type=template&id=9ea5b19a&scoped=true"
import script from "./main-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./main-layout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./main-layout.vue?vue&type=style&index=0&id=9ea5b19a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea5b19a",
  null
  
)

export default component.exports